/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type AvailabilityDelayEnum =
  (typeof AvailabilityDelayEnum)[keyof typeof AvailabilityDelayEnum];

export const AvailabilityDelayEnum = {
  '1w': '1w',
  '2w': '2w',
  '3w': '3w',
  '1m': '1m',
  '2m+': '2m+',
} as const;
